import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useGetScheduleDowntimeList = (id, type, status) => {
    return useQuery(QUERY_KEY.GET_SCHEDULE_DOWNTIME_LIST, () => ApiService.getScheduleDowntimeList(id, type, status))
}

export default useGetScheduleDowntimeList